module.exports = {"data":{"site":{"siteMetadata":{"title":"Razy Technologies"}},"allMarkdownRemark":{"totalCount":1,"edges":[{"node":{"fields":{"slug":"/blog/brand-success-only-with-the-right-consumer-data/"},"frontmatter":{"title":"Brand Success: Only with the right consumer data"}}}]}},"pathContext":{"tag":"consumer"}}


//////////////////
// WEBPACK FOOTER
// ./~/json-loader!./.cache/json/tags-consumer.json
// module id = 456
// module chunks = 72499185232889